import React from 'react';
import _noop from 'lodash/noop';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';

import { IContentProps } from '../types';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from './formConfig';
import useContent from './useContent';

const Content = (props: IContentProps) => {
	const { handleForceUpdate = _noop, kycId } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useContent({ handleForceUpdate, kycId });

	return (
		<div className={css({ width: '50vw' })}>
			<div>Are you sure you want to Reject KYC of the user ?</div>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				validationSchema={validationSchema}
				buttonLabels={{
					submitLabel: 'Reject',
					discardLabel: 'Cancel'
				}}
				hidePopUp
			/>
		</div>
	);
};

export default Content;
